import { Timestamp } from "firebase/firestore";

export enum TransactionCategory {
	FOOD = 'FOOD',
	GROCERY = 'GROCERY',
	ENTERTAINMENT = 'ENTERTAINMENT',
	TRANSPORT = 'TRANSPORT',
	SHOPPING = 'SHOPPING',
	UTILITIES = 'UTILITIES',
	HEALTHCARE = 'HEALTHCARE',
	OTHER = 'OTHER'
}

export interface Transaction {
	id?: string;
	userId: string;
	timestamp: Timestamp;
	amount: number;
	shopName: string;
	source: string;
	category: string;
	budgetGroup: string;
	paidBy: string;
	splitAmounts?: { [userId: string]: number };
}

export interface UserProfile {
	userId: string;
	friendlyName: string;
	budgetGroups: string[];
	defaultBudgetGroup: string;
	joinedAt?: Timestamp;
}

export interface BudgetGroup {
	id: string;
	friendlyName: string;
	createdBy: string;
	userIds: string[];
	createdAt: Timestamp;
}

export interface CreateBudgetGroupInviteProps {
	currentUser: UserProfile;
	budgetGroup: BudgetGroup;
	invitedEmail: string;
}

export interface BudgetGroupInvite {
	id: string;
	groupId: string;
	groupName: string;
	invitedBy: string;
	invitedByName: string;
	invitedUserId: string;
	timestamp: Timestamp;
}
